import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import { useState } from 'react';
import { CertificateWrapper } from './CertifcateWrapper';
import { FilterCertificates } from './Filter';
import { Main } from './styles';

export const Certificates = (): JSX.Element => {
  const options = [
    {
      value: '2026/2027',
      label: '2026/2027',
    },
    {
      value: '2025/2026',
      label: '2025/2026',
    },
    {
      value: '2024/2025',
      label: '2024/2025',
    },
    {
      value: '2023/2024',
      label: '2023/2024',
    },
  ];

  const [selectedPeriodRecent, setSelectedPeriodRecent] = useState(
    options[0].label,
  );
  const [period, setPeriod] = useState('');

  const handlePeriodRecent = option => {
    setSelectedPeriodRecent(option);
    setPeriod('');
  };

  const handlePeriodChange = event => {
    setPeriod(event.target.value);
    setSelectedPeriodRecent('');
  };

  return (
    <>
      <Header />
      <Menu />
      <Main>
        <FilterCertificates
          period={period}
          handlePeriodRecent={handlePeriodRecent}
          setPeriod={handlePeriodChange}
          selectedPeriodRecent={selectedPeriodRecent}
          options={options}
        />
        <CertificateWrapper
          title="Declarações"
          selectedPeriodRecent={selectedPeriodRecent}
          periodSelect={period}
          setSelectedPeriodRecent={setSelectedPeriodRecent}
        />
      </Main>
    </>
  );
};
